// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { AppThemeProvider } from './theme/AppThemeProvider';

import keycloak from './keycloak';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <ReactKeycloakProvider authClient={keycloak}>
            <AppThemeProvider>
                <App />
            </AppThemeProvider>
        </ReactKeycloakProvider>
    </BrowserRouter>
);

reportWebVitals();
